export const getMapBoundsForSite = (map, maps, siteSettingsData) => {
  const bounds = new maps.LatLngBounds();

  bounds.extend(
    new maps.LatLng(
      siteSettingsData.UpperLeftLatitude,
      siteSettingsData.UpperLeftLongitude
    )
  );
  var lowerRightLatitude =
    siteSettingsData.UpperLeftLatitude -
    2 *
      (siteSettingsData.UpperLeftLatitude -
        siteSettingsData.CenterPointLatitude);
  var lowerRightLongitude =
    siteSettingsData.UpperLeftLongitude +
    2 *
      (siteSettingsData.CenterPointLongitude -
        siteSettingsData.UpperLeftLongitude);
  bounds.extend(new maps.LatLng(lowerRightLatitude, lowerRightLongitude));

  map.fitBounds(bounds);
};
